<template>
    <div>
        <Banner/>

        <div class="w">
            <div class="row_1">
                <div>
                    <CarouselArticleListWindow :isHomePage="isHomePage" :articleModel="this.$route.query.articleModel+'01'" icon="el-icon-notebook-2" title="系部新闻" style="height: 420px;"/>
                </div>
                <div>
                    <ArticleListWindow :isHomePage="isHomePage" :articleModel="this.$route.query.articleModel+'02'" icon="el-icon-mic" title="学生风采" style="height: 420px;"/>
                </div>
            </div>
            <div class="row_2">
                <div>
                    <ArticleListWindow :isHomePage="isHomePage" :articleModel="this.$route.query.articleModel+'03'" icon="el-icon-user" title="教学动态" style="height: 420px;"/>
                </div>
                <div>
                    <ArticleListWindow :isHomePage="isHomePage" :articleModel="this.$route.query.articleModel+'04'" icon="el-icon-video-camera-solid" title="党团工作" style="height: 420px;"/>
                </div>
                <div>
                    <ArticleListWindowTwo :isHomePage="isHomePage" :articleModel="this.$route.query.articleModel+'05'" icon="el-icon-video-camera-solid" title="专业设置" style="height: 420px;"/>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
    import Banner from "@/components/Banner"
    import ArticleListWindow from "@/components/ArticleListWindow"
    import ArticleListWindowTwo from "@/components/ArticleListWindowTwo"
    import CarouselArticleListWindow from "@/components/CarouselArticleListWindow"

    
    export default {
        name: 'DepartmentContent',
        components: {Banner, ArticleListWindow, CarouselArticleListWindow, ArticleListWindowTwo},
        data() {
            return {
                isHomePage: '0'
            }
        }
    }
</script>
<style scoped>
    .w {
        width: 100%;
    }

    .w>div {
        margin-top: 30px;
    }
    .row_1 {
        display: flex;
    }
    .row_1>div:first-child {
        flex: 2;
        margin: 0 0.05rem;
    }
    .row_1>div:last-child {
        flex: 1;
    }

    .row_2 {
        display: flex;
    }
    .row_2>div {
        flex: 1;
        margin: 0 0.05rem;
    }

    @media screen and (max-width: 768PX) {
        .row_1, .row_2 {
            width: 100%;
            display: block;
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/pages/DepartmentContent.vue